/* Header-over-hero state.
   The nav is transparent while the hero is behind it and returns to its solid
   --mist state once the hero's lower edge has passed under the nav. Applies to
   every template that opts in (index, about, journal, stone-match) — the markup
   side is fs-nav--overlay in sections/fs-header.liquid.

   Deliberately a scroll listener rather than an IntersectionObserver. The
   observer version depended on a root element and a rootMargin that had to
   match the header height, was silent when either was wrong, and could not be
   verified without a live scroll. This reads two numbers off the layout and
   compares them, which is inspectable at any moment. */
(() => {
  const run = () => {
    const header = document.querySelector('[data-fs-home-header]');
    const hero = document.querySelector('.hero-under-header');
    if (!header || !hero) return;

    const desktop = window.matchMedia('(min-width: 981px)');
    // 手机上也压在 hero 上的页面会在 <body> 上标出来。没有这一句的话,下面那个分支
    // 会在 981 以下无条件删掉 .is-solid,nav 就会透明一整页,而不是只在 hero 上。
    const overlayOnMobile = document.body.classList.contains('header-over-hero-mobile');
    let frame = 0;

    const update = () => {
      frame = 0;
      if (!desktop.matches && !overlayOnMobile) {
        // Below the breakpoint the nav never overlays, so it must stay solid.
        header.classList.remove('is-solid');
        return;
      }
      // Both rects are viewport-relative, so this works whether the page scrolls
      // on the window or inside Horizon's .page-wrapper — no need to know which.
      const headerBottom = header.getBoundingClientRect().bottom;
      const heroBottom = hero.getBoundingClientRect().bottom;
      header.classList.toggle('is-solid', heroBottom <= headerBottom);
    };

    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    // The scroll may happen on the window or on an overflow container between the
    // hero and the document, so listen in the capture phase and catch either.
    document.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    desktop.addEventListener('change', update);
    update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
